import { CoreFormFieldDate } from '../fields/CoreFormFieldDate';
import { FormFieldContainer } from '../layout/FormFieldContainer';
import type { ContextFormFieldBaseProps } from './ContextFormFieldBaseProps';
import type { FormFieldControllerRulesProps } from './FormFieldController';
import { FormFieldController } from './FormFieldController';

export const ContextFormFieldDate = ({
  fieldPath,
  rules,
  disabled,
  label,
  inline,
  placeholder,
  helperText,
  colSpan,
}: ContextFormFieldBaseProps) => {
  return (
    <FormFieldContainer colSpan={colSpan}>
      <FormFieldController
        name={fieldPath}
        rules={rules as FormFieldControllerRulesProps}
      >
        {({ field, fieldState }) => (
          <CoreFormFieldDate
            label={rules?.required ? `${label} *` : label}
            error={fieldState.error?.message?.toString()}
            inputProps={{
              id: fieldPath,
              ...field,
              disabled,
              placeholder,
            }}
            inline={inline}
            helperText={helperText}
          />
        )}
      </FormFieldController>
    </FormFieldContainer>
  );
};
